import { HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { IconType } from "react-icons";
import { FiHash, FiMail, FiPhone, FiUser } from "react-icons/fi";
import type { BuyerBidDetailDto } from "../../../autogen/bff-api";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";
import { getBidContactSummary } from "./bidContact";

interface Props {
  detail: BuyerBidDetailDto;
}

export const BidContactCard = ({ detail }: Props) => {
  const { t } = useTranslation();
  const contact = getBidContactSummary(detail, t("more"));
  const rows = [
    { icon: FiUser, label: t("Contact person"), value: contact.contactName },
    { icon: FiMail, label: t("Email"), value: contact.email },
    { icon: FiPhone, label: t("Phone"), value: contact.phone },
    { icon: FiHash, label: t("Organization number"), value: contact.organizationNumber },
  ];

  return (
    <SectionCard icon={FiUser} title={t("Contact information")}>
      <Stack spacing="3">
        {rows.map((row) => (
          <ContactRow key={row.label} icon={row.icon} label={row.label} value={row.value} />
        ))}
      </Stack>
    </SectionCard>
  );
};

const ContactRow = ({ icon, label, value }: { icon: IconType; label: string; value: string }) => (
  <HStack spacing="3" align="flex-start">
    <Icon as={icon} boxSize="4" color="smMuted" mt="0.5" />
    <Stack spacing="0" minW="0">
      <Text fontSize="xs" color="smMuted" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
        {label}
      </Text>
      <Text fontSize="sm" color="smText" wordBreak="break-word">
        {value}
      </Text>
    </Stack>
  </HStack>
);
